module.exports = __webpack_public_path__ + "static/img/partner-yahoo.2ea6080d.png";